<template>
  <div class="match-invite-page page">
    <!-- 顶部 -->
    <page-top></page-top>
    <!-- 头部 -->
    <Header @chooseTab="getTab" currentIndex="6"></Header>
    <!-- 主体 -->
    <main class="main">
      <section class="breadcrumb-plate">
        <div class="label">我的位置：</div>
        <breadcrumb />
      </section>

      <section class="w">
        <div class="c-top">
          <tabbar
            :tabData="tabList"
            :code="categoryId"
            :seccode="seccode"
            :subcode="subcode"
            @changeSecTab="changeSecTab"
          ></tabbar>
        </div>
      </section>
      <section class="w">
        <div class="title-wrap">
          <span class="c-title">{{ currentCategory?.categoryName }}</span>
          <span class="english-name">{{ currentCategory?.englishName }}</span>
        </div>
      </section>
      <section class="content w">
        <div class="c-left">
          <!-- 内容 -->
          <div v-html="article.articleContent"></div>
        </div>
        <div class="c-right">
          <div id="map"></div>
        </div>
      </section>
    </main>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import pageTop from '@/components/common/pageTop.vue'
import Header from '@/components/train/header.vue'
import Footer from '@/components/train/footer.vue'
import Breadcrumb from '@/components/common/breadcrumb'
import { getArticleById } from '@/api/home/home.js'
import { getNavItemByCode } from '@/api/common/common.js'
import Tabbar from '@/components/list/tabbar.vue'

export default {
  name: 'Policy',
  components: { pageTop, Header, Footer, Breadcrumb, Tabbar },
  data() {
    return {
      concatList: [
        //   {
        //   key: "联系电话",
        //   value: "0597-2332345"
        // },
        {
          key: '手机',
          value: '13695005173'
        },
        {
          key: '邮箱',
          value: '157235262@qq.com'
        },
        {
          key: '联系地址',
          value: ' 福建省厦门市集美区后溪镇珩圣路386号226室'
        }
      ],
      pageSize: 6, //分页数量
      pageCount: 0, //列表总数
      displayNewsList: true,

      tabList: [],
      tabTitle: '新闻中心',
      newsList: [],
      article: '',
      pageType: '', //1 文章内容，2 文章列表
      categoryId: '',
      tabcode: '',
      seccode: '',
      subcode: '',
      currentCategory: {
        categoryName: '',
        englishName: ''
      },
      markerArr: [
        {
          id: '1', //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
          styleId: 'myStyle', //指定样式id
          position: new window.TMap.LatLng(24.633265, 118.075707), //点标记坐标位置
          properties: {
            //自定义属性
            title: '地址：'
          }
        }
      ]
    }
  },
  methods: {
    //统一获取数据
    fetchData() {
      if (!this.tabcode) return
      getNavItemByCode(this.tabcode).then((res) => {
        if (!res.data) return
        //侧边栏列表
        this.tabList = res.data[0]
        if (this.categoryId == this.tabList.categoryCode) {
          this.currentCategory = this.tabList
        } else if (
          this.currentCategory.categoryName == '' &&
          this.tabList.list
        ) {
          this.currentCategory = this.tabList.list.find(
            (p) => this.categoryId == p.categoryCode
          )
        }
      })
    },
    //点击改变栏目
    changeSecTab(item, tab) {
      this.currentCategory = item
      console.log('item', this.currentCategory)
      console.log('tab', tab)
      let url =
        '?categoryId=' +
        item.categoryCode +
        '&linkType=' +
        item.linkType +
        '&tabcode=' +
        this.tabcode
      url = tab ? url + '&seccode=' + tab : url

      this.seccode = tab //二级标题
      this.categoryId = item.categoryCode //当前标题
      this.subcode = item.categoryCode //三级标题
      this.pageType = item.linkType
      if (this.tabList.list && this.tabList.list.length > 0) {
        const targetItem = this.tabList.list.find(
          (item) => item.categoryCode == this.categoryId
        )

        if (this.categoryId == this.seccode && targetItem?.list?.length) {
          item = item.list[0]
          this.seccode = targetItem.categoryCode
          this.subcode = targetItem.list[0].categoryCode
          this.categoryId = targetItem.list[0].categoryCode
        }
      }

      // 展示富文本
      //链接类型：1/文章详情,2/单图列表,3/图文列表,4/文本列表,5/切换详情列表
      if (item.linkType == 1) {
        url = '/train/article' + url + '&id=' + item.linkUrl
      }
      if (item.linkType == 2) {
        url = '/train/singleImage' + url
      }
      if (item.linkType == 3) {
        url = '/train/imageText' + url
      }
      if (item.linkType == 4) {
        url = '/train/textList' + url
      }
      if (item.linkType == 5) {
        url = '/train/tabList' + url
      }
      if (item.linkType == 9) {
        alert(item.linkUrl)
        url = '/train/contactUs' + url + '&id=' + item.linkUrl
      }

      this.$router.push({
        path: url
      })
    },
    //获取header组件的点击事件
    getTab(data) {
      if (data && typeof data == 'string') {
        this.$router.push('/' + data)
      }
    },
    initMap() {
      //设置一个默认的中心点
      var center = new window.TMap.LatLng(24.633265, 118.075707)
      //初始化地图
      var map = new window.TMap.Map(document.getElementById('map'), {
        center: center, //设置地图中心点坐标
        zoom: 16 //设置地图缩放级别
        // pitch: 43.5,  //设置俯仰角
        // rotation: 45    //设置地图旋转角度
      })
      //设定marker点及其样式
      var markerLayer = new window.TMap.MultiMarker({
        map: map, //指定地图容器
        //样式定义
        styles: {
          //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
          myStyle: new window.TMap.MarkerStyle({
            width: 25, // 点标记样式宽度（像素）
            height: 35 // 点标记样式高度（像素）
            // "src": './images/R-C.png',  //图片路径
            //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
            // "anchor": { x: 16, y: 32 }  //marker点图片跟据焦点位置的偏移量
          })
        },
        //点标记数据数组
        geometries: this.markerArr
        // 点标记数组格式
        //   geometries: [
        //     {
        //     "id": "1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
        //     "styleId": 'myStyle',  //指定样式id
        //     "position": new window.TMap.LatLng(24.638627, 118.073705),  //点标记坐标位置
        //     "properties": {//自定义属性
        //       "title": "荆州万达广场",
        //     }
        //   }
        // ]
      })

      //设置信息窗口
      var infoWindow = new window.TMap.InfoWindow({
        map: map,
        position: new window.TMap.LatLng(24.628959, 118.064711), //信息窗口默认位置
        offset: { x: 0, y: -32 } //设置信息窗相对position偏移像素，为了使其显示在Marker的上方
      })

      //信息窗口设置完后默认是打开的 可以先关闭初始信息窗口
      infoWindow.close()
      //监听marker点击事件
      markerLayer.on('click', function (evt) {
        infoWindow.open() // 打开信息窗
        infoWindow.setPosition(evt.geometry.position) // 设置信息窗位置
        infoWindow.setContent(
          `<div id="infoPopup" stationId="${evt.geometry.id}" style="cursor: pointer;min-width: 300px;display:flex;justify-content: space-between;align-items: center;"><div style="display:flex;flex-direction: column;align-items: flex-start;padding: 14px;font-size: 16px;line-height: 2em;">
          <div>${evt.geometry.properties.title}</div><div style="color: #666;"> 福建省厦门市集美区后溪镇珩圣路386号226室
        
        </div></div>
         
          </div>`
        ) // 设置信息窗内容
        document
          .querySelector('#infoPopup')
          .addEventListener('click', function () {})
      })
      // 监听地图点击事件
      // map.on('click',function(evt){
      // console.log("evt",evt);
      // })
    },

    // 文章信息--富文本
    getArticleData(id) {
      getArticleById(id).then((res) => {
        if (!res.data) return
        this.article = res.data
      })
    }
  },
  created() {
    this.pageType = this.$route.query?.linkType
    this.categoryId = this.$route.query?.categoryId
    this.tabcode = this.$route.query?.tabcode
    this.seccode = this.$route.query?.seccode
    this.fetchData()
    let id = this.$route.query?.id
    if (id != 'null' && id) return this.getArticleData(id)
  },
  mounted() {
    setTimeout(() => {
      this.initMap()
    }, 50)
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-breadcrumb__inner.is-link,
::v-deep .el-breadcrumb__inner.is-link:hover {
  color: #fff;
}
::v-deep .el-breadcrumb__separator,
::v-deep .el-breadcrumb__separator:hover {
  color: #fff;
}
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner,
::v-deep.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  color: #fff;
}

.match-invite-page {
  .main {
    flex: 1;
    padding-bottom: 80px;
    background-color: #ffffff;
    margin-top: 60px;

    .breadcrumb-plate {
      background: linear-gradient(to top, #347cd0 0%, #62a3f0 100%);
      color: #fff;

      display: flex;
      align-items: center;
      padding: 16px 0;
      padding-left: 180px;

      .label {
        line-height: 1;
        font-size: 14px;
      }
    }
    .title-wrap {
      margin-top: 60px;
      .c-title {
        font-size: 28px;
        padding-left: 17px;
        border-left: 3px solid rgb(12, 108, 228);
        font-weight: 700;
      }
      .english-name {
        color: rgb(153, 153, 153);
        margin-left: 10px;
      }
    }

    .content {
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      margin-top: 30px;
      margin-bottom: 100px;

      .c-top {
        display: flex;
        justify-content: center;
      }

      .c-left {
        flex: 1;
        background-color: #fff;
        padding-bottom: 100px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;

        .item-detail {
          padding: 6px;
          :nth-child(1) {
            font-size: 18px;
            font-weight: 700;
          }
          :nth-child(2) {
            font-size: 16px;
          }
        }
      }
      .c-right {
        flex: 1;
        margin-left: 20px;
      }
    }
  }
}
.map-wrap {
  margin-top: 60px;
}
</style>
